import { gql } from "@apollo/client";

export const GET_ADMIN_INDICACIONES = gql`
    query GetAdminIndicaciones($idDelegacion: Int!, $idEstado: Int!) {
        adminIndicaciones(idDelegacion: $idDelegacion, idEstado: $idEstado) {
        success,
        error,
        valorEsperado {
            idIndicacionAprobacion,
            idEvaluacion,
            fechaContrato,
            fechaIndicacionActual,
            fechaIndicacionNueva,
            idPaciente,
            paciente,
            programa,
            planCuidado,
            idCliente,
            cliente,
            idEstadoIndicacionAprobacionMedico,
            estadoAprobacionMedico,
            idEstadoIndicacionAprobacionComercial,
            estadoAprobacionComercial,
            fechaSolicitud,
            permisoMedico,
            fechaDesdeContrato,
            fechaHastaContrato
            }
        }
    }
`;